import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';

import { isOrNotConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import PriorityDropdown from 'components/UI/PriorityDropdown/PriorityDropdown';

const LeadPriorityFilter = ({ index }) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              name={field.name}
              options={isOrNotConditionOptions}
              onChange={(e) => field.onChange(e.value)}
              value={field.value}
              filter
              className="w-100 input-shadow"
              placeholder="Select"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <PriorityDropdown
              value={field.value?.['case_details.priority'] || ''}
              name={field.name}
              onChange={(e) => field.onChange({ 'case_details.priority': e.value })}
              filter
              className="w-100 input-shadow"
              placeholder="Select"
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default LeadPriorityFilter;
